import { Clipper } from "../../../clipper";
import { mat3 } from "../../../common";
/** Given a compound primitive (union/difference), returns the inner shapes transformed with the compound matrix */
export function chainCompoundPrimitiveTransforms(parentPrimitive) {
    // TODO: Check if order is correct
    const newTransformA = mat3.multiply(parentPrimitive.transform, parentPrimitive.primitiveA.transform);
    const newTransformB = mat3.multiply(parentPrimitive.transform, parentPrimitive.primitiveB.transform);
    const newTransformAInverse = mat3.multiply(parentPrimitive.primitiveA.transformInverse, parentPrimitive.transformInverse);
    const newTransformBInverse = mat3.multiply(parentPrimitive.primitiveB.transformInverse, parentPrimitive.transformInverse);
    return [
        {
            ...parentPrimitive.primitiveA,
            // Role and layer of the children is ignored, the parent wins
            role: parentPrimitive.role,
            layerId: parentPrimitive.layerId,
            transform: newTransformA,
            transformInverse: newTransformAInverse,
        },
        {
            ...parentPrimitive.primitiveB,
            role: parentPrimitive.role,
            layerId: parentPrimitive.layerId,
            transform: newTransformB,
            transformInverse: newTransformBInverse,
        },
    ];
}
export function resizePolygonByExpansion(polygon, expansion, options) {
    const resizedShape = Clipper.shape([polygon], true).offset(expansion, options);
    const vectors = resizedShape.toPolygons();
    return vectors[0] ?? undefined;
}
export function booleanUnionPolygons(polygonA, polygonB) {
    const shapeBClipper = Clipper.shape([polygonB], true);
    const outputShape = Clipper.shape([polygonA], true).union([shapeBClipper]);
    const vectors = outputShape.toPolygons();
    return vectors[0] ?? undefined;
}
export function booleanDifferencePolygons(polygonA, polygonB) {
    const shapeBClipper = Clipper.shape([polygonB], true);
    // Ensure that `polygonB` is not 0-area. In some cases, a 0-area polygon can be created from something like a
    // 0-radius circle. This causes invalid paths to be generated by Clipper, and the library throws an error.
    let outputShape = Clipper.shape([polygonA], true);
    if (shapeBClipper.totalArea() > 0) {
        outputShape = outputShape.subtract([shapeBClipper]);
    }
    const vectors = outputShape.toPolygons();
    return vectors[0] ?? undefined;
}
//# sourceMappingURL=utils.js.map